/* eslint-disable react/prefer-stateless-function */
import React, { Suspense, lazy } from 'react'
import { Redirect } from 'react-router-dom'
import RetailerRoute, { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import DocumentTitle from 'legacy/components/DocumentTitle'
import RetailerSwitch from 'legacy/components/RetailerSwitch'
import { InventoryFilesAccessControl } from 'legacy/routes/reports/files/InventoryFiles.configuration'
import { TlogsContainerAccessControl } from 'legacy/routes/reports/tlogs/TlogsContainer.configuration'
import { AlcoholTlogsAccessControl } from 'legacy/routes/reports/alcohol/AlcoholTlogs.configuration'
import { RxTlogsAccessControl } from 'legacy/routes/reports/rx/RxTlogs.configuration'
import { TopProductsAccessControl } from 'legacy/routes/reports/analytics/top-products/TopProducts.configuration'
import { PerformanceMetricsAccessControl } from 'legacy/sections/analytics/components/performance-metrics/PerformanceMetrics.configuration'
import { ReportsNormalizedReportsListPage } from 'domains/reports/pages/normalized-reports-list/ReportsNormalizedReportsListPage'
import { ReportsNormalizedReportsListPageAccessControl } from 'domains/reports/pages/normalized-reports-list/ReportsNormalizedReportsListPage.configuration'
import { ReportsPickupAnalyticsPage } from 'domains/reports/pages/pickup-analytics/ReportsPickupAnalyticsPage'
import { ReportsPickupAnalyticsAccessControl } from 'domains/reports/pages/pickup-analytics/ReportsPickupAnalytics.configuration'

const Loading = () => null

const InventoryFiles = lazy(
  () => import(/* webpackChunkName: "inventory-files" */ './files/InventoryFiles')
)

const Tlogs = lazy(() => import(/* webpackChunkName: "tlogs" */ './tlogs/TlogsContainer'))

const AlcoholTlogs = lazy(
  () => import(/* webpackChunkName: "alcohol-tlogs" */ './alcohol/AlcoholTlogs')
)

const RxTlogs = lazy(() => import(/* webpackChunkName: "rx-tlogs" */ './rx/RxTlogs'))

const PerformanceMetrics = lazy(
  () =>
    import(/* webpackChunkName: "performance-metrics" */ './analytics/PerformanceMetricsContainer')
)

const TopProducts = lazy(() =>
  import(
    /* webpackChunkName: "top-products-availability" */ './analytics/top-products/TopProducts'
  ).then(module => ({ default: module.TopProducts }))
)

class Reports extends React.Component<RetailerRouteComponentProps> {
  render() {
    return (
      <Suspense fallback={<Loading />}>
        <RetailerSwitch>
          <RetailerRoute
            route="files"
            exact
            render={props => (
              <DocumentTitle titleId="reports.files.title">
                <InventoryFiles {...props} />
              </DocumentTitle>
            )}
            accessControl={InventoryFilesAccessControl}
          />
          <RetailerRoute
            route="tlogs"
            exact
            render={props => (
              <DocumentTitle titleId="reports.tlogs.title">
                <Tlogs {...props} />
              </DocumentTitle>
            )}
            accessControl={TlogsContainerAccessControl}
          />
          <RetailerRoute
            route="alcohol-tlogs"
            exact
            render={props => (
              <DocumentTitle titleId="alcoholTlogs.title">
                <AlcoholTlogs {...props} />
              </DocumentTitle>
            )}
            accessControl={AlcoholTlogsAccessControl}
          />
          <RetailerRoute
            route="rx-tlogs"
            exact
            render={props => (
              <DocumentTitle titleId="rxTlogs.title">
                <RxTlogs {...props} />
              </DocumentTitle>
            )}
            accessControl={RxTlogsAccessControl}
          />
          <RetailerRoute
            route="performance-metrics"
            exact
            render={props => (
              <DocumentTitle titleId="performanceMetrics.title">
                <PerformanceMetrics {...props} />
              </DocumentTitle>
            )}
            accessControl={PerformanceMetricsAccessControl}
          />
          <RetailerRoute
            route="top-products"
            exact
            render={props => (
              <DocumentTitle titleId="topProducts.title">
                <TopProducts {...props} />
              </DocumentTitle>
            )}
            accessControl={TopProductsAccessControl}
          />
          <RetailerRoute
            route="pickupAnalytics"
            exact
            component={ReportsPickupAnalyticsPage}
            accessControl={ReportsPickupAnalyticsAccessControl}
          />

          <RetailerRoute
            route="reports-normalized-reports-list"
            exact
            component={ReportsNormalizedReportsListPage}
            accessControl={ReportsNormalizedReportsListPageAccessControl}
          />

          <Redirect
            from="/partners/:partner_id/warehouses/:warehouse_id/reports"
            to="/partners/:partner_id/warehouses/:warehouse_id/reports/files"
          />
        </RetailerSwitch>
      </Suspense>
    )
  }
}

export default Reports
